import type { Dispatch } from 'react';
import React from 'react';
import type { TrackingService } from '../models/tracking-service';
import type { Action, State } from './reducers/tracking-reducer';
import reducer from './reducers/tracking-reducer';

export type TrackingState = {
  trackingService: TrackingService | null;
};

export const defaultState: TrackingState = {
  trackingService: null,
};

export const trackingStateContext = React.createContext<State | null>(null);
export const trackingDispatchContext = React.createContext<Dispatch<Action> | null>(null);

const Provider = ({
  children,
  trackingService,
}: {
  children: React.ReactNode;
  trackingService?: TrackingService;
}) => {
  const [state, dispatch] = React.useReducer(reducer, {
    ...defaultState,
    trackingService: trackingService || null,
  });

  return (
    <trackingStateContext.Provider value={state}>
      <trackingDispatchContext.Provider value={dispatch}>
        {children}
      </trackingDispatchContext.Provider>
    </trackingStateContext.Provider>
  );
};

function useTrackingState() {
  const context = React.useContext(trackingStateContext);
  if (!context) {
    throw new Error('useTrackingState must be used within a Provider');
  }
  return context;
}

function useTrackingDispatch() {
  const context = React.useContext(trackingDispatchContext);
  if (!context) {
    throw new Error('useTrackingDispatch must be used within a Provider');
  }
  return context;
}

export default { Provider, useTrackingState, useTrackingDispatch };
